(() => {
  if (customElements.get('yhr-product-rail')) return;
  customElements.define('yhr-product-rail', class extends HTMLElement {
    connectedCallback() {
      const rail = this.querySelector('[data-home-rail]');
      const controls = this.querySelector('[data-rail-controls]');
      const previous = this.querySelector('[data-rail-previous]');
      const next = this.querySelector('[data-rail-next]');
      if (!rail || !controls || !previous || !next) return;
      this.abort?.abort();
      this.resize?.disconnect();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const update = () => {
        const max = rail.scrollWidth - rail.clientWidth;
        const position = Math.abs(rail.scrollLeft);
        controls.hidden = max < 2;
        previous.disabled = position < 2;
        next.disabled = position >= max - 2;
      };
      const move = direction => rail.scrollBy({
        left: direction * rail.clientWidth * (getComputedStyle(rail).direction === 'rtl' ? -1 : 1),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      rail.addEventListener('scroll', update, { ...options, passive: true });
      this.resize = new ResizeObserver(update);
      this.resize.observe(rail);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
    }
  });
})();
